module.exports = __webpack_public_path__ + "img/mision.a0dc8bde.png";